import useApi from "../../api/useApi";

const useCreditService = () => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'user/company/credits',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {
        throw new Error(`Error in useCreditService::userShow: ${error?.message || JSON.stringify(error)}`)
      },
    )
  }

  const userShowCollection = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'user/credits',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {
        throw new Error(`Error in useCreditService::userShowCollection: ${error?.message || JSON.stringify(error)}`)
      },
    )
  }

  const adminStore = (callbackSuccess, callbackValidationErrors, id, data) => {
    return api(
      'post',
      'admin/credits/store',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {
        throw new Error(`Error in useCreditService::adminStore: ${error?.message || JSON.stringify(error)}`)
      },
      data,
    )
  }

  return {
    userShow,
    userShowCollection,
    adminStore
  }
}


export default useCreditService;